module.exports = __webpack_public_path__ + "img/activities-25.cf9d80c8.jpg";